const UserStatisticsPage = () => import('@/pages/statistics/user/UserStatisticsPage.vue')
const ArgillaStatistics = () => import('@/pages/statistics/ArgillaStatistics.vue')
const OneDMStatistics = () => import('@/pages/statistics/OneDMStatistics.vue')
const DoubleMaterialityStatistics = () => import('@/pages/statistics/DoubleMaterialityStatistics.vue')
const IssueCategoriesStatistics = () => import('@/pages/statistics/IssueCategoriesStatistics.vue')
const DMXMonitoringStatistics = () => import('@/pages/statistics/DMXMonitoringStatistics.vue')
const MainStoriesStatistics = () => import('@/pages/statistics/MainStoriesStatistics.vue')
const MongoChartsPage = () => import('@/pages/statistics/MongoChartsPage.vue')

export default [
	{
		path: '/usage_statistics',
		component: UserStatisticsPage,
		props: {
			permission: ['usage_statistics', 'r']
		}
	},
	{
		path: '/mongo_charts',
		component: MongoChartsPage,
		props: {
			permission: ['usage_statistics', 'r']
		}
	},
	{
		path: '/statistics/argilla',
		component: ArgillaStatistics,
		props: {
			permission: ['argilla_statistics', 'r']
		}
	},
	{
		path: '/statistics/one-dm',
		component: OneDMStatistics,
		props: {
			permission: ['one_dm', 'r']
		}
	},
	{
		path: '/statistics/double-materiality-edit',
		component: DoubleMaterialityStatistics,
		props: {
			permission: ['usage_statistics', 'r']
		}
	},
	{
		path: '/statistics/issue-categories',
		component: IssueCategoriesStatistics,
		props: {
			permission: ['usage_statistics', 'r']
		}
	},
	{
		path: '/statistics/dmx-monitoring',
		component: DMXMonitoringStatistics,
		props: {
			permission: ['usage_statistics', 'r']
		}
	},
	{
		path: '/statistics/main-stories',
		component: MainStoriesStatistics,
		props: {
			permission: ['usage_statistics', 'r']
		}
	}
]
